<script>
  import { showListimModalShow } from '@ducks/layout'
  import { bindAction } from '@store'
  import Button from '@components/Button'
  import { onMount } from 'svelte'

  const showListimModalShowBindAction = bindAction(showListimModalShow)
  const showListimModal = e => {
    e.preventDefault()
    showListimModalShowBindAction(id)
  }
  export let id, className

  let isTerminal;

  onMount(() => {
    isTerminal = localStorage.isTerminal;
  });
</script>


{#if !isTerminal}
  <Button
    className="text-uppercase {className || ''}"
    background="#0c6954"
    type="button"
    on:click={showListimModal}><slot></slot>
  </Button>
{/if}